<template>
  <div>
    <div>Vui lòng soạn hợp đồng cho khách hàng theo thông tin và nhập kết quả xử lý vào bên dưới.</div>
    <div class="field-label step4-handle-file-contract mt-4 m-10 p-4 rounded" style="border: #5E00B6 solid 2px; box-shadow: 0px 12px 11px rgba(0, 0, 0, 0.25);">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <label class="mb-1">Kết quả xử lý <span class="text-danger">*</span></label>
          <el-select class="w-100" v-model="formStep4.result" placeholder="Chọn kết quả xử lý">
            <el-option
                v-for="item in resultHandle"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="mb-1">Số tiền vay <span class="text-danger">*</span></label>
          <el-input
              placeholder="Nhập số tiền vay"
              clearable
              :value="formatVND(formStep4.loan_amount)"
              @input="onAmountInput"
          />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="mb-1">Hạn thanh toán hàng tháng <span class="text-danger">*</span></label>
          <date-picker
              :clearable="false"
              placeholder="Chọn thời gian"
              v-model="formStep4.deadLine"
              @change="validateDeadLine"
              format="DD-MM-YYYY"
              valueType="YYYY-MM-DD"
              :disabled-date="disabledPastDate"
          ></date-picker>
        </div>
      </div>

      <div class="mt-4">
        <label>Link hợp đồng <span class="text-danger"> *</span></label>
        <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="Nhập link hợp đồng"
            v-model="formStep4.contract_link"
            @blur="validateContractLink">
        </el-input>
      </div>

      <div class="mt-4">
        <label>Ghi chú <span class="text-danger"></span></label>
        <ckeditor :editor="editor"  v-model="formStep4.note"></ckeditor>
      </div>
      <div class="d-flex justify-content-end align-items-center mt-4">
        <el-button style="background-color: #CACACA" @click="clear()" size="mini" class="rounded">Hủy</el-button>
        <el-button
            style="background-color: #5D04B0"
            @click="saveStep4"
            class="text-white rounded"
            size="mini"
            :disabled="!canSaveStep4 || loadingStep4"
        >
          <i :class="loadingStep4 ? 'el-icon-loading' : ''"></i>
          Lưu kết quả
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomEditor from "@/core/plugins/ckeditor5/custom-editor";
import moment from 'moment-timezone';
import {SAVE_RESULT_CALL_TVV, SAVE_RESULT_CONTRACT} from "../../../../core/services/store/customer/customer-crm.module";
import DatePicker from "vue2-datepicker";

export default {
  name: "step4HandleFileContract",
  components: {
    DatePicker

  },
  data() {
    return {
      editor: CustomEditor,
      formStep4: {
        result: 'drafted',
        note: '',
        loan_amount: '',
        deadLine: '',
        monthly_due_day: '',
        contract_link: '',
      },
      loadingStep4: false,
      resultHandle: [
        { value: 'drafted', label: 'Đã soạn hợp đồng' },
      ]
    }
  },

  computed: {
    canSaveStep4() {
      return !!(
          this.formStep4.result &&
          this.formStep4.loan_amount !== '' &&
          this.formStep4.loan_amount !== null &&
          this.formStep4.loan_amount !== undefined &&
          this.formStep4.deadLine &&
          this.formStep4.contract_link &&
          this.formStep4.contract_link.trim()
      );
    }
  },

  mounted() {

  },

  methods: {
    saveStep4() {
      this.loadingStep4 = true;
      const noteLength = this.formStep4.note
          ? this.formStep4.note.replace(/<[^>]*>/g, '').trim().length
          : 0;

      if (!this.canSaveStep4) {
        this.$notify({
          title: 'Thiếu dữ liệu!',
          message: 'Vui lòng nhập đủ Kết quả xử lý, Số tiền vay, Hạn thanh toán và Link hợp đồng!',
          type: 'warning'
        });
        this.loadingStep4 = false;
        return;
      }

      if (!this.isValidUrl(this.formStep4.contract_link)) {
        this.$notify({
          title: 'Sai dữ liệu!',
          message: 'Link hợp đồng không đúng định dạng!',
          type: 'warning'
        });
        this.loadingStep4 = false;
        return;
      }

      if (noteLength > 200) {
        this.$notify({
          title: 'Sai dữ liệu!',
          message: 'Ghi chú không được dài quá 200 kí tự!',
          type: 'warning'
        });
        this.loadingStep4 = false;
        return;
      }

      const payload = {
        id: this.$route.params.id,
        result: this.formStep4.result,
        note: this.formStep4.note,
        loan_amount: this.formStep4.loan_amount,
        monthly_due_day: this.formStep4.monthly_due_day,
        contract_link: this.formStep4.contract_link,
      };

      this.$store.dispatch(SAVE_RESULT_CONTRACT, payload)
          .then((res) => {
            if (!res.error) {
              this.$emit('next-step-5');
              this.clear();
            }
          })
          .catch((e) => {
            this.$notify({
              title: 'Thất bại!',
              message: e.data?.message ? e.data.message : 'Thất bại!',
              type: 'warning'
            });
          })
          .finally(() => {
            this.loadingStep4 = false;
          });
    },

    isValidUrl(url) {
      if (!url || typeof url !== 'string') return false;

      try {
        const parsed = new URL(url.trim());
        return ['http:', 'https:'].includes(parsed.protocol);
      } catch (e) {
        return false;
      }
    },

    formatVND(val) {
      if (val > 500000000) {
        this.$notify({
          title: 'Sai dữ liệu!',
          message: 'Số tiền vay không được lớn hơn 500 triệu đồng!',
          type: 'warning'
        });
        this.formStep4.loan_amount = '';
        return '';
      }

      if (val === null || val === undefined || val === '') return '';
      const n = Number(String(val).replace(/\D/g, ''));
      if (!n) return '';
      return n.toLocaleString('vi-VN');
    },

    onAmountInput(value) {
      const raw = String(value || '').replace(/\D/g, '');
      this.formStep4.loan_amount = raw ? Number(raw) : '';
    },

    validateDeadLine(item) {
      const day = moment(item).date();

      if (day === 31) {
        this.$notify({
          title: 'Sai dữ liệu!',
          message: 'Không được chọn ngày 31',
          type: 'warning'
        });
        this.formStep4.deadLine = '';
        this.formStep4.monthly_due_day = '';
        return false;
      }

      this.formStep4.monthly_due_day = day;
      return day;
    },

    validateContractLink() {
      if (!this.formStep4.contract_link) return;

      if (!this.isValidUrl(this.formStep4.contract_link)) {
        this.$notify({
          title: 'Sai dữ liệu!',
          message: 'Link hợp đồng không đúng định dạng!',
          type: 'warning'
        });
      }
    },

    disabledPastDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },

    clear() {
      this.formStep4 = {
        result: 'drafted',
        note: '',
        loan_amount: '',
        deadLine: '',
        monthly_due_day: '',
        contract_link: '',
      };
    }
  }
}
</script>

<style scoped>
.step4-handle-file-contract {
  text-align: left;
}

.field-label {
  margin-top: 10px;
  text-align: left;
}
</style>


